import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import * as oPath from '../../../Lib/Object/Path/Mutable';
import { ServiceSetupState, SetValueAction, SyncResolveAction } from './types';

const name = 'serviceSetup';

const initialState: ServiceSetupState = {
  connection: {},
  connection_synced: {},
  databaseConnectionTest: {
    error: null,
    testing: false,
    success: false,
  },
  qestnetRestart: {
    restarting: false,
    restarted: false,
    error: null,
  },
  status: {
    message: undefined,
    dirty: false,
    synchronising: false,
    initialising: true,
    retrievingData: false,
  },
  isDatabaseConfigured: false,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    getDatabaseConfigured: (state) => {
      state.status.initialising = true;
    },
    getDatabaseConfiguredResolve: (state, { payload: isConfigured }: PayloadAction<boolean>) => {
      state.status.initialising = false;
      state.isDatabaseConfigured = isConfigured;
    },
    getDatabaseConfiguredReject: (state) => {
      state.status.initialising = false;
    },
    getDatabaseConnection: (state) => {
      state.status.retrievingData = true;
    },
    getDatabaseConnectionResolve: (state, { payload: data }: PayloadAction<any>) => {
      state.status.retrievingData = false;
      state.connection = data;
      state.connection_synced = data;
    },
    getDatabaseConnectionReject: (state) => {
      state.status.retrievingData = false;
    },
    testDatabaseConnection: (state) => {
      state.databaseConnectionTest.testing = true;
      state.databaseConnectionTest.success = false;
      state.databaseConnectionTest.error = null;
      state.status.message = { severity: 'info', message: 'Testing database connection...' };
    },
    testDatabaseConnectionResolve: (state) => {
      state.databaseConnectionTest.testing = false;
      state.databaseConnectionTest.success = true;
      state.databaseConnectionTest.error = null;
      state.status.message = { severity: 'success', message: 'Test was successful. Please restart QESTNet to log in.' };
    },
    testDatabaseConnectionReject: (state, { payload: error }: PayloadAction<any>) => {
      state.databaseConnectionTest.testing = false;
      state.databaseConnectionTest.success = false;
      state.status.message = { severity: 'error', message: error.message };
    },
    restartQestnet: (state) => {
      state.qestnetRestart.restarting = true;
      state.qestnetRestart.restarted = false;
      state.qestnetRestart.error = null;
      state.status.message = { severity: 'info', message: 'Starting the QEST Platform...' };
    },
    restartQestnetReject: (state, { payload: error }: PayloadAction<any>) => {
      state.qestnetRestart.restarting = false;
      state.qestnetRestart.restarted = false;
      state.status.message = { severity: 'error', message: error.message };
    },
    sync: (state) => {
      state.status.synchronising = true;
    },
    syncResolve: (state, action: SyncResolveAction) => {
      state.status.synchronising = false;
      if (action.payload?.syncPatch) {
        state.connection = action.payload?.syncPatch;
        state.connection_synced = action.payload?.syncPatch;
      }
    },
    setValue: (state, action: SetValueAction) => {
      const { payload: { name, value } = {} } = action;
      oPath.set(state.connection, name, value, true);
      state.status.message = undefined;
      state.databaseConnectionTest.success = false;
    },
  },
});

const { actions, reducer } = slice;
export { actions, reducer };
